export default __webpack_public_path__ + "static/blno-unedited-65e46e78dc884ca14de967eca54af3cb.png";